import { mapState, mapGetters } from 'vuex'
import vueScroll from 'vuescroll';
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Drawer',
  components: {
    vueScroll
  },
  data () {
    return {
      loaded: false,
      serviceFunctionModel: null,

      registerHash: Constants.RegisterHash,
      scrollOptions: {
        rail: {
          opacity: '0',
          background: undefined,
          gutterOfEnds: '5px',
          gutterOfSide: '5px',
          size: '5px'
        },
        bar: {
          opacity: '0.5',
          background: '#fff',
          keepShow: false,
          size: '5px',
          minSize: 0.2
        },
        scrollButton: {
          enable: false
        },
        scrollPanel: {
          easing: 'easeInQuad',
          speed: 800
        },
        vuescroll: {
          wheelScrollDuration: 0,
          wheelDirectionReverse: false
        }
      },
      openGroupList: []
    }
  },
  mounted () {
    if (this.isOperator) {
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionListGet'],
        [{
          serviceUuid: this.userServiceUuid
        }])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.$set(this, 'serviceFunctionModel', res[0].data.serviceFunctions)

            this.loaded = true
            // resize
            $(window).on({
              resize: this.onResize
            })
            this.onResize()

          } else if (status.error) {
            console.log('error')
          } else {
            console.log('error')
          }
        })
        .catch(error => {
          console.log('error')
        })

    } else {
      this.loaded = true
      // resize
      $(window).on({
        resize: this.onResize
      })
      this.onResize()
    }
  },
  computed: {
    ...mapState({
      authorized: state => state.auth.authorized,
      requireChangePassword: state => state.auth.requireChangePassword,
      activeGlobalMenu: state => state.core.activeGlobalMenu
    }),
    ...mapGetters({
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedGroup: 'permission/permittedGroup',
      permittedView: 'permission/permittedView',
    }),
    
    showVideoChat() {
      console.log(this.serviceFunctionModel)
      return this.isOperator
        ? this.serviceFunctionModel
          ? this.serviceFunctionModel
            .findIndex(item => item.deliveryType === null) !== -1
          : false
        : true
    },
  },
  methods: {
    onResize () {
      let windowWidth = window.innerWidth ?
        window.innerWidth : $(window).width()
      let windowHeight = window.innerHeight ?
        window.innerHeight : $(window).height()

      let h = windowHeight - $('#header').outerHeight()
      $('#drawer > .wrap').height(h)
    },
    isActiveGroup (className) {
      if (!this.$route.name) return false

      let pathArray = this.$route.path.split('/')
      if(pathArray[0] === '') pathArray.shift()
      if(pathArray[pathArray.length - 1] === '') pathArray.pop()

      // ドロップダウンが開いていればfalse
      if (this.openGroupList.findIndex(item => item === className) !== -1) return false

      // サービス管理
      // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
      if (className === 'group.service') {
        return pathArray[0] === 'service' ||
          pathArray[0] === 'file' ||
          pathArray[0] === 'bot' ||
            pathArray[0] === 'partner'
      }
      // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED
      // マスタ管理
      if (className === 'group.masta') {
        return pathArray[0] === 'deliveryTypeMst' ||
          pathArray[0] === 'noticeTypeMst' ||
          pathArray[0] === 'linkedCmsMst' ||
          pathArray[0] === 'screenConfigMst' ||
          pathArray[0] === 'screenIdMst' ||
          pathArray[0] === 'spAppMst'
      }
      // アカウント管理
      if (className === 'group.user') {
        return pathArray[0] === 'user'
      }
      // お知らせ管理
      if (className === 'group.notice') {
        return pathArray[0] === 'notice'
      }
      // ログ管理
      if (className === 'group.log') {
        return pathArray[0] === 'log'
      }
      // ADMP管理
      if (className === 'group.admp') {
        return pathArray[0] === 'tenant' ||
          pathArray[0] === 'community' ||
          pathArray[0] === 'device'
      }
    },
    isActive (category) {
      if (!this.$route.name) return false

      let pathArray = this.$route.path.split('/')
      if(pathArray[0] === '') pathArray.shift()
      if(pathArray[pathArray.length - 1] === '') pathArray.pop()
      // console.log('isActive | ', pathArray + ' : ' +  this.$route.name + ' : ' + category)
    
      // サービス管理
      if (category === 'Service') {
        if (pathArray[0] === 'service' &&
          pathArray[1] === undefined)
          return true
        return pathArray[0] === 'service' &&
          pathArray[1] !== '-' &&
          pathArray[2] === 'detail'
      }
      if (category === 'ServiceForm') {
        return pathArray[0] === 'service' &&
          pathArray[1] === '-' &&
          (pathArray[2] === 'form' ||
          pathArray[2] === 'confirm')
      }
      if (category === 'File') {
        return pathArray[0] === 'file'
      }
      if (category === 'Bot') {
        return pathArray[0] === 'bot'
      }
      // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
      if (category === 'Partner') {
        return pathArray[0] === 'partner'
      }
      // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED

      // マスタ管理
      if (category === 'DeliveryTypeMst') {
        return pathArray[0] === 'deliveryTypeMst'
      }
      if (category === 'NoticeTypeMst') {
        return pathArray[0] === 'noticeTypeMst'
      }
      if (category === 'LinkedCmsMst') {
        return pathArray[0] === 'linkedCmsMst'
      }
      if (category === 'ScreenConfigMst') {
        return pathArray[0] === 'screenConfigMst'
      }
      if (category === 'ScreenIdMst') {
        return pathArray[0] === 'screenIdMst'
      }
      if (category === 'SpAppMst') {
        return pathArray[0] === 'spAppMst'
      }
    
      // アカウント管理
      if (category === 'User') {
        if (pathArray[0] === 'user' &&
          pathArray[1] === undefined)
          return true
        return pathArray[0] === 'user' &&
          pathArray[1] !== '-' &&
          pathArray[2] === 'form'
      }
      if (category === 'UserForm') {
        return pathArray[0] === 'user' &&
          pathArray[1] === '-' &&
          pathArray[2] === 'form'
      }
    
      // お知らせ管理
      if (category === 'Notice') {
        if (pathArray[0] === 'notice' &&
          pathArray[1] === undefined)
          return true
        return pathArray[0] === 'notice' &&
          pathArray[1] !== '-' &&
          pathArray[2] === 'detail'
      }
      if (category === 'NoticeForm') {
        return pathArray[0] === 'notice' &&
          pathArray[1] === '-' && 
          (pathArray[2] === 'selector' ||
          pathArray[2] === 'form' ||
          pathArray[2] === 'confirm')
      }
    
      // ログ管理
      if (category === 'Log') {
        return pathArray[0] === 'log' &&
          pathArray[1] === undefined
      }
      if (category === 'LogDownload') {
        return pathArray[0] === 'log' &&
          pathArray[1] === 'download'
      }
    
      // ADMP管理
      if (category === 'Tenant') {
        return pathArray[0] === 'tenant'
      }
      if (category === 'Community') {
        return pathArray[0] === 'community'
      }
      if (category === 'Device') {
        return pathArray[0] === 'device'
      }
    
      // ささえiでんわ管理
      if (category === 'VideoChat') {
        return pathArray[0] === 'videoChat'
      }
    
      // マイアカウント
      if (category === 'MyAccount') {
        return pathArray[0] === 'myAccount' &&
          pathArray[1] === undefined
      }

      // ロケーション管理
      if (category === 'Location') {
        return pathArray[0] === 'location'
      }
    },

    toggleGroup (className) {
      // console.log(className)
      let group = $('.' + className).children('dl')
      let target = group.children('dd')

      // close
      if (group.hasClass('show')) {
        group.removeClass('show')
        target.slideUp(500, 'easeOutQuint', () => {
          // console.log('closed')
        })
        
        this.$set(this, 'openGroupList', Utility.removeArray(this.openGroupList, className))

      // open
      } else {
        group.addClass('show')
        target.slideDown(500, 'easeOutQuint', () => {
          // console.log('opend')
        })

        this.openGroupList.push(className)
      }
    }
  }
}